import { Avatar } from '@mui/material'
import { stringAvatar } from 'components/DataGrid/gridOperators'

type AvatarItem = {
  name?: string
}
const StringAvatar = ({
  item,
  bgColor,
  borderColor,
  fontSize,
  size,
}: {
  item: AvatarItem
  bgColor?: string
  borderColor?: string
  fontSize?: string
  size?: number
}) => {
  return (
    <Avatar
      {...stringAvatar(item?.name, { fontSize: fontSize ?? 18 })}
      sx={{
        backgroundColor: bgColor ?? 'background.defaultdim',
        border: `1px solid ${borderColor ?? 'rgb(114, 229, 218)'}`,
        width: size ?? 34,
        height: size ?? 34,
        objectFit: 'cover',
        objectPosition: 'center',
      }}
    />
  )
}

export default StringAvatar
